import { LOCAL_STORAGE_KEY_LANGUAGE } from '@core/constant/constant';
import { LocalStorageService } from '@core/services/local-storage.service';
import { TranslateService } from '@ngx-translate/core';

export const PRICING_DEFAULT_LANGUAGE = 'al';
const PRICING_SUPPORTED_LANGUAGES = new Set(['al', 'en']);

/** Resolves the pricing flow language from local storage, defaulting to Albanian. */
export function resolvePricingLanguage(localStorageService: LocalStorageService): string {
  const saved = localStorageService.getData(LOCAL_STORAGE_KEY_LANGUAGE)?.trim();
  if (saved && PRICING_SUPPORTED_LANGUAGES.has(saved)) {
    return saved;
  }
  return PRICING_DEFAULT_LANGUAGE;
}

/** Applies pricing flow language (saved choice or Albanian default). */
export function applyPricingLanguage(
  translate: TranslateService,
  localStorageService: LocalStorageService
): void {
  translate.setDefaultLang(PRICING_DEFAULT_LANGUAGE);
  translate.use(resolvePricingLanguage(localStorageService));
}
